var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoiceIcon03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0015 2C9.38146 2 7.25146 4.13 7.25146 6.75C7.25146 9.32 9.26147 11.4 11.8815 11.49C11.9615 11.48 12.0415 11.48 12.1015 11.49C12.1215 11.49 12.1315 11.49 12.1515 11.49C12.1615 11.49 12.1615 11.49 12.1715 11.49C14.7315 11.4 16.7415 9.32 16.7515 6.75C16.7515 4.13 14.6215 2 12.0015 2Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.0795 14.1528C14.2895 12.2928 9.73947 12.2928 6.92947 14.1528C5.65947 15.0028 4.95947 16.1528 4.95947 17.3828C4.95947 18.6128 5.65947 19.7528 6.91947 20.5928C8.31947 21.5328 10.1595 22.0028 11.9995 22.0028C13.8395 22.0028 15.6795 21.5328 17.0795 20.5928C18.3395 19.7428 19.0395 18.6028 19.0395 17.3628C19.0295 16.1328 18.3395 14.9928 17.0795 14.1528Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9985 16.6328H12.7485V15.3828C12.7485 14.9728 12.4085 14.6328 11.9985 14.6328C11.5885 14.6328 11.2485 14.9728 11.2485 15.3828V16.6328H9.99854C9.58854 16.6328 9.24854 16.9728 9.24854 17.3828C9.24854 17.7928 9.58854 18.1328 9.99854 18.1328H11.2485V19.3828C11.2485 19.7928 11.5885 20.1328 11.9985 20.1328C12.4085 20.1328 12.7485 19.7928 12.7485 19.3828V18.1328H13.9985C14.4085 18.1328 14.7485 17.7928 14.7485 17.3828C14.7485 16.9728 14.4085 16.6328 13.9985 16.6328Z",
    fill: "#333448",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIcon03);
export default __webpack_public_path__ + "static/media/voice-icon-03.bb58f6957ac8afdb3e85def4cefe0438.svg";
export { ForwardRef as ReactComponent };